const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`2dcfb43c0e422b860893ac1b572084b9eb13c516505268cdbd2cf4ff2a0aadd3`, `2dcfb43c0e422b860893ac1b572084b9eb13c516505268cdbd2cf4ff2a0aadd3`, 1, 80), new Map([[`heading`, `SmashingConf New York`], [`href`, `https://cloudfour.com`], [`reverse_markup`, true]]), false, false, 1));
            }

            getTemplateName() {
                return `2dcfb43c0e422b860893ac1b572084b9eb13c516505268cdbd2cf4ff2a0aadd3`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `2dcfb43c0e422b860893ac1b572084b9eb13c516505268cdbd2cf4ff2a0aadd3`, ``);
            }
        }],
        [80, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/media-summary/media-summary.twig`, `2dcfb43c0e422b860893ac1b572084b9eb13c516505268cdbd2cf4ff2a0aadd3`, 1);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/media-summary/media-summary.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/calendar-date/calendar-date.twig`, new Map([[`datetime`, `2022-07-14T23:25:59.626Z`], [`note`, `3-day event`]]), false, false, 7));
                this.echo(`  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p>New York, NY</p>
    <p>Speakers: Megan, Aileen</p>
  `);
            }

            getTemplateName() {
                return `2dcfb43c0e422b860893ac1b572084b9eb13c516505268cdbd2cf4ff2a0aadd3`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `2dcfb43c0e422b860893ac1b572084b9eb13c516505268cdbd2cf4ff2a0aadd3`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '2dcfb43c0e422b860893ac1b572084b9eb13c516505268cdbd2cf4ff2a0aadd3');

let template = env.loadTemplate('2dcfb43c0e422b860893ac1b572084b9eb13c516505268cdbd2cf4ff2a0aadd3');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/media-summary/demo/event.twig", args: context }
     );
     return rendered;;
};